import allimg from '@/assets/ctstatus/all.png';
import reviewimg from '@/assets/ctstatus/review.png';
import rejectimg from '@/assets/ctstatus/reject.png';
import payimg from '@/assets/ctstatus/pay.png';
import refundimg from '@/assets/ctstatus/refund.png';
import refundingimg from '@/assets/ctstatus/refunding.png';
import complateimg from '@/assets/ctstatus/complate.png';
import closeimg from '@/assets/ctstatus/close.png';

export const tabs = [
  { key: '', name: '全部', icon: allimg },
  { key: 3, name: '待审核', icon: reviewimg, count: 0 },
  { key: 2, name: '审核不通过', icon: rejectimg, count: 0 },
  { key: 4, name: '待支付', icon: payimg, count: 0 },
  { key: 14, name: '待退保', icon: refundingimg, count: 0 },
  { key: 5, name: '已完成', icon: complateimg },
  { key: 7, name: '已关闭', icon: closeimg },
  { key: 13, name: '已退保', icon: refundimg },
];

export const useColumn = (bindcompany) => {
  let columns = [
    {
      title: '编号',
      dataIndex: 'code',
      scopedSlots: { customRender: 'code' },
      width: 170,
    },
    {
      title: '项目名称',
      dataIndex: 'project',
      scopedSlots: { customRender: 'project' },
      ellipsis: true,
    },
    {
      title: '受益人',
      dataIndex: 'proprietor',
      scopedSlots: { customRender: 'proprietor' },
      ellipsis: true,
    },
    {
      title: '开标时间',
      dataIndex: 'kbdate',
      width: 150,
      sorter: true,
    },
  ];
  if (bindcompany) {
    columns.push({
      title: '申请人',
      dataIndex: 'bidder',
      scopedSlots: { customRender: 'bidder' },
      ellipsis: true,
    });
  }
  columns.push(
    ...[
      {
        title: '担保金额',
        dataIndex: 'money',
        width: 100,
        slots: { customRender: 'money' },
        customRender: (text) => {
          return text + '元';
        },
        sorter: true,
      },
      {
        title: '担保费',
        dataIndex: 'poundage',
        slots: { customRender: 'poundage' },
        customRender: (text) => {
          return text + '元';
        },
        width: 80,
        sorter: true,
      },
      {
        title: '出函时间',
        dataIndex: 'sign_time',
        sorter: true,
        width: 150,
      },
      {
        title: '支付时间',
        dataIndex: 'pay_time',
        sorter: true,
        width: 150,
      },
      {
        title: '保函状态',
        dataIndex: 'status',
        scopedSlots: { customRender: 'status' },
        width: 75,
      },
      {
        title: '操作',
        dataIndex: 'id',
        scopedSlots: { customRender: 'action' },
        width: 155,
      },
    ],
  );
  return columns;
};
